import { SmopBannerTypeEnum } from "@saleor/types/globalTypes";
import Moment from "moment";
export const useCreateBannerValidation = initialForm => {
  const {
    endDate,
    name,
    startDate,
    type,
    startTime,
    endTime,
    verticals
  } = initialForm;

  const dateToday = new Date().setUTCHours(0, 0, 0, 0).toLocaleString() + "";

  const newStartDate = startDate
    ? startDate
    : Moment(dateToday).format("yyyy-MM-dd");

  const endDateMessage = () => {
    if (!endDate) {
      return "This field is required";
    } else if (newStartDate > endDate) {
      return "End date should be later than start date.";
    }
    return null;
  };
  const nameMessage = () => {
    if (
      type === SmopBannerTypeEnum.ANNOUNCEMENT &&
      (name === "" || name === null)
    ) {
      return "This field is required.";
    }

    return null;
  };
  const startDateMessage = () => {
    if (!startDate) {
      return "This field is required.";
    }
    return null;
  };

  const startTimeMessage = () => {
    if (startTime === "" || startTime === null) {
      return "This field is required.";
    }
    return null;
  };

  const endTimeMessage = () => {
    if (endDate) {
      if (endTime === "" || endTime === null) {
        return "This field is required.";
      }
      return null;
    }
    return null;
  };

  const verticalMessage = () => {
    if (verticals.length === 0) {
      return "This field is required.";
    }
    return null;
  };

  const checkDates = () => {
    const start = Moment(startDate + " " + startTime);
    const end = Moment(endDate + " " + endTime);
    if (start > end) {
      return "Start Time should be earlier than the End Time";
    }
    return null;
  };

  return {
    endDate: endDateMessage(),
    endTime: endTimeMessage() || checkDates(),
    name: nameMessage(),
    startDate: startDateMessage(),
    startTime: startTimeMessage(),
    verticals: verticalMessage()
  };
};

export const hasNoError = validationError => {
  let thisReturn = true;
  Object.keys(validationError).forEach(key => {
    if (thisReturn) {
      thisReturn = validationError[key] === null;
    }
  });
  return thisReturn;
};
